import { createStore } from '@shared/store';
import { UserDetailsType } from '@shared/types';
import { ServiceLocationDetailsObjectType, CaseIDProps } from '@types';
import { CheckboxOption } from '@molecules/*';

type ServiceLocationDetailsType = ServiceLocationDetailsObjectType & {
  additional_details?: string;
};

const initialData = {
  uploadedImages: [],
  uploadedImagesFileName: [],
  uploadedImagesFileType: [],
  uploadedImagesBlob: [],
  wantConfirmationEmail: null,
  canBeContacted: null,
  caseReferenceId: '',
  slaText: '',
  userDetails: {
    firstName: '',
    lastName: '',
    email: '',
    contactId: '',
  },
  sessionId: '',
  isStrayDog: null,
  issueLocation: '',
  issueTypes: [],
  issueInfo: '',
  recurringIssue: {
    isRecurringIssue: null,
    whenDidItHappen: '',
  },
  serviceLocationDetails: {} as ServiceLocationDetailsType,
  fileWithLoadedCoordinates: '',
  isPhotoLocationStored: false,
  issueLocationMoreInfo: '',
  confirmation: undefined,
};

interface StoreType {
  uploadedImages: string[];
  uploadedImagesFileName: string[];
  uploadedImagesFileType: string[];
  uploadedImagesBlob: {
    blob_uri: string;
    blob_endpoint: string;
    filename: string;
  }[];
  wantConfirmationEmail: boolean | null;
  canBeContacted: boolean | null;
  caseReferenceId: string;
  slaText: string;
  userDetails: UserDetailsType;
  sessionId: string;
  isStrayDog: boolean | null;
  issueLocation: string;
  issueTypes: CheckboxOption[];
  issueInfo: string;
  recurringIssue: {
    isRecurringIssue: boolean | null;
    whenDidItHappen: string;
  };
  serviceLocationDetails: ServiceLocationDetailsType;
  fileWithLoadedCoordinates: string;
  isPhotoLocationStored: boolean;
  issueLocationMoreInfo: string;
  confirmation: CaseIDProps | undefined;
}

export const useAnimalNuisanceStore = createStore<StoreType>({
  initialData,
  name: 'animal-nuisance-store',
  persist: true,
  enableDevTools: false,
});

/**
 * Function to reset user details
 * Note: use getState() to access Zustand store method outside of a React component
 * */
export const resetUserDetails = () => {
  useAnimalNuisanceStore
    .getState()
    .resetSelective(['userDetails', 'sessionId']);
};

/**
 * Function to reset issue details
 * Note: use getState() to access Zustand store method outside of a React component
 * */
export const resetIssueDetails = () => {
  useAnimalNuisanceStore
    .getState()
    .resetSelective([
      'isStrayDog',
      'issueLocation',
      'fileWithLoadedCoordinates',
      'issueLocation',
      'issueInfo',
      'recurringIssue.isRecurringIssue',
      'recurringIssue.whenDidItHappen',
      'serviceLocationDetails',
      'issueTypes',
      'isPhotoLocationStored',
      'issueLocationMoreInfo',
      'uploadedImages',
      'uploadedImagesFileName',
      'uploadedImagesFileType',
      'uploadedImagesBlob',
      'canBeContacted',
    ]);
};

export const updateStoreByKey = (key: string, value: any) => {
  useAnimalNuisanceStore.getState().update(key as keyof StoreType, value);
};
